export default __webpack_public_path__ + "static/bentoSectionBg5-83427227b8ef1c564298e6a28d62ca9f.webp";